<div #colorPickerContainer class="rgb-picker-container dropdown-container">
    <div class="picker-preview" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggleColorPicker()">
        <div class="color-preview-container">
            <div class="color-preview-box" [ngStyle]="{ 'background-color': colorValueHex }"></div>
        </div>
        <span class="color-hex">{{ colorValueHex }}</span>
    </div>

    <ng-template
        #colorPicker
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isPickerOpen"
        [cdkConnectedOverlayPositions]="preferredPositions"
        [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    >
        <div class="color-picker-overlay">
            <color-sketch
                class="color-picker"
                [ngStyle]="{ display: isPickerOpen ? 'block' : 'none' }"
                [color]="colorValueHex"
                [disableAlpha]="disableOpacitySlider"
                [presetColors]="presetColors"
                (click)="$event.stopPropagation()"
                (onChangeComplete)="colorSelected($event)"
            ></color-sketch>
        </div>
    </ng-template>
</div>
